import { useEcho } from '@laravel/echo-vue'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { useHeaderMetricsStore } from '@/store/headerMetricsStore'

import { ECHO_CHANNELS } from '@/constants/echoChannels'

export function useHeaderMetrics() {
    const authorizationStore = useAuthorizationStore()
    const headerMetricsStore = useHeaderMetricsStore()

    const slug = authorizationStore.getWorkspaceSlug

    if (!slug || slug === '_') {
        return
    }

    const channel = ECHO_CHANNELS.headerMetrics()

    if (!channel) {
        return
    }

    headerMetricsStore.loadHeaderCalls()

    useEcho(
        channel,
        '.header-metrics-update',
        (payload) => {
            headerMetricsStore.setHeaderCalls(payload)
        },
    )
}
